import styled from 'styled-components';

export const RollbackBadge = styled.button`
  display: flex;
  gap: 14px;
  align-items: center;
  border: none;
  outline: none;
  background-color: transparent;
  padding: 0;

  span {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.tab.main};
    transition: 0.4s ease-in-out all;
  }

  p {
    font-size: ${({ theme }) => theme.fonts.label['font-size']};
    font-weight: 500;
    line-height: ${({ theme }) => theme.fonts.label['line-height']};
  }

  cursor: pointer;

  &:hover {
    span {
      transform: scale(1.1);
    }
  }
`;
